"use client"

import { useEffect } from "react"

type HeadHtmlInjectorProps = {
  html?: string | null
}

// Admin "headerScripts" là HTML thô do người dùng dán vào (thường tự chứa các thẻ
// <script>…</script>, ví dụ GTM/Meta Pixel). Không được render trực tiếp qua
// dangerouslySetInnerHTML bên trong một thẻ <script> cha — trình duyệt đóng thẻ cha
// ngay tại </script> lồng đầu tiên rồi parse phần còn lại thành các node <head> anh em
// mà React không biết tới → hydration mismatch (#418). Component này render null trên
// server, khi mount ở client mới dựng lại đúng các node thật (kể cả <script>) vào
// document.head, ngoài luồng render của React nên không gây mismatch.
export default function HeadHtmlInjector({ html }: HeadHtmlInjectorProps) {
  useEffect(() => {
    if (!html) return

    const container = document.createElement("div")
    container.innerHTML = html

    const injectedNodes: Node[] = []

    Array.from(container.childNodes).forEach(node => {
      if (node.nodeName === "SCRIPT") {
        const source = node as HTMLScriptElement
        const script = document.createElement("script")
        Array.from(source.attributes).forEach(attr => script.setAttribute(attr.name, attr.value))
        script.text = source.text
        document.head.appendChild(script)
        injectedNodes.push(script)
      } else {
        const clone = node.cloneNode(true)
        document.head.appendChild(clone)
        injectedNodes.push(clone)
      }
    })

    return () => {
      injectedNodes.forEach(node => {
        if (node.parentNode === document.head) {
          document.head.removeChild(node)
        }
      })
    }
  }, [html])

  return null
}
